// VAT (Fiji): 9 % → 15 % from 1 Aug 2023 → 12.5 % from 1 Aug 2025. A contract can set its own rate (e.g. 15 % at
// signing) and the date it changed (e.g. 12.5 % from 1 Aug 2025); without one, the Fiji rate on the date is used.
// VEP = excluding VAT, VIP = including VAT. Shared by the app and the server functions (no imports).

export type VatChange = { from: string; pct: number };
export const FIJI_VAT: VatChange[] = [
  { from: '0000-01-01', pct: 9 },
  { from: '2023-08-01', pct: 15 },
  { from: '2025-08-01', pct: 12.5 },
];

const today = () => new Date().toISOString().slice(0, 10);

/** The Fiji standard VAT rate on a date (YYYY-MM-DD; default today). */
export function fijiVat(date?: string | null): number {
  const d = (date ?? today()).slice(0, 10);
  let pct = FIJI_VAT[0].pct;
  for (const c of FIJI_VAT) if (c.from <= d) pct = c.pct;
  return pct;
}

/** A contract's VAT rate on a date: its own rate + changes when set, else the Fiji rate on that date. */
export function vatOn(c: { vat_pct?: number | string | null; vat_changes?: VatChange[] | null } | null | undefined, date?: string | null): number {
  const d = (date ?? today()).slice(0, 10);
  if (!c || c.vat_pct === null || c.vat_pct === undefined || c.vat_pct === '') return fijiVat(d);
  let pct = Number(c.vat_pct);
  for (const ch of [...(c.vat_changes ?? [])].sort((a, b) => a.from.localeCompare(b.from))) if (ch.from && ch.from <= d && Number.isFinite(Number(ch.pct))) pct = Number(ch.pct);
  return pct;
}

const r2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;
export const toVip = (vep: number, pct: number) => r2(vep * (1 + pct / 100));
export const toVep = (vip: number, pct: number) => r2(vip / (1 + pct / 100));
export const pctText = (pct: number) => `${pct % 1 ? pct.toFixed(1) : pct} %`;

/** The other basis of an amount: a VIP amount gives its VEP and the other way round. */
export function otherBasis(amount: number, basis: 'VEP' | 'VIP', pct: number): { amount: number; basis: 'VEP' | 'VIP' } {
  return basis === 'VIP' ? { amount: toVep(amount, pct), basis: 'VEP' } : { amount: toVip(amount, pct), basis: 'VIP' };
}
